import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../store/store";

import CashCountService from "../../services/cash/cashCountService";

import {

    startAudit,
    finishAudit,
    setDetails,
    updateResult,
    setObservations,
    setLoading

} from "../../store/slices/cash/cashCountSlice";

import useAlerts from "../useAlerts";
import useApiErrorHandler from "../useApiErrorHandler";
import useLoading from "../useLoading";

import { useCashSession } from "./useCashSession";

export const useCashCount = () => {

    const dispatch: AppDispatch = useDispatch();

    const {

        auditStarted,
        countId,
        countNumber,
        expectedAmount,
        countedAmount,
        difference,
        details,
        observations,
        loading

    } = useSelector((state: RootState) => state.cashCount);

    const { show: showAlert } = useAlerts();
    const { handle } = useApiErrorHandler();

    const { showLoadingIndicator, hideLoadingIndicator } = useLoading();

    const { getActiveSession } = useCashSession();

    /**
     * ▶️ Iniciar auditoría
     */
    const start = async () => {

        try {

            showLoadingIndicator();
            dispatch(setLoading(true));

            const response = await CashCountService.start();
            console.log(response);


            if (response?.statusCode === 200) {

                const data = response.data;

                dispatch(startAudit({
                    id: data.id,
                    countNumber: data.countNumber,
                    expectedAmount: data.expectedAmount
                }));

                showAlert(
                    response.type,
                    response.title,
                    response.message
                );

            }

        } catch (error) {

            handle(error);

        } finally {

            hideLoadingIndicator();
            dispatch(setLoading(false));

        }

    };

    /**
 * 🔎 Recuperar arqueo activo
 */
    const getActive = async () => {

        try {

            const response = await CashCountService.getActive();
            console.log(response);

            if (response?.statusCode === 200 && response.data) {

                const data = response.data;

                dispatch(startAudit({
                    id: data.id,
                    countNumber: data.countNumber,
                    expectedAmount: data.expectedAmount
                }));

            }

        } catch (error) {

            handle(error);

        }

    };

    /**
     * ✅ Finalizar auditoría
     */
    const complete = async () => {

        if (!countId) return;

        try {

            showLoadingIndicator();
            dispatch(setLoading(true));

            const payload = {

                details,
                countedAmount,
                difference,
                observations

            };

            const response = await CashCountService.complete(countId, payload);
            console.log(response);

            if (response?.statusCode === 200) {

                showAlert(
                    response.type,
                    response.title,
                    response.message
                );

                dispatch(finishAudit());

                await getActiveSession();

            }

        } catch (error) {

            handle(error);

        } finally {

            hideLoadingIndicator();
            dispatch(setLoading(false));

        }

    };

    /**
     * 🧾 Actualizar denominaciones
     */
    const updateDenominations = (newDetails: any[]) => {

        dispatch(setDetails(newDetails));

        const countedAmount = newDetails.reduce(

            (total, item) => total + (item.denomination * item.quantity),

            0

        );

        const diff = countedAmount - expectedAmount;

        dispatch(updateResult({

            countedAmount,
            difference: diff

        }));

    };

    /**
     * ✏️ Observaciones
     */
    const updateObservation = (value: string) => {

        dispatch(setObservations(value));

    };

    const reset = () => {
        dispatch(finishAudit());
    };

    return {

        auditStarted,
        countId,
        countNumber,

        expectedAmount,
        countedAmount,
        difference,

        details,
        observations,

        loading,

        start,
        getActive,
        complete,

        updateDenominations,
        updateObservation,

        reset 

    };

};